<template>
  <div>
    <div class="md-layout-item">
      <form>
        <md-card>
          <md-card-header class="md-card-header-text md-card-header-green">
            <div class="card-text">
              <h4 class="title">البحث</h4>
            </div>
          </md-card-header>

          <!-- <div class="md-layout-item md-size-25 md-medium-size-50 md-xsmall-size-100">
            <md-card>
              <md-card-content class="text-center">
                <h5 class="card-text">A title with a text under</h5>
                <md-button class="md-success" @click.native="showSwal('title-and-text')">Try me!</md-button>
              </md-card-content>
            </md-card>
          </div> -->

          <md-card-content>
            <div class="md-layout mtb-25">
              <div
                class="md-layout-item md-size-30 md-small-size-100 ml-15 mt-25"
              >
                <md-field>
                  <label>الادارة</label>
                  <md-select v-model="departmentId">
                    <md-option
                      v-for="department in departments"
                      v-bind:key="department.id"
                      :value="department.id"
                      >{{ department.name }}</md-option
                    >
                  </md-select>
                </md-field>
              </div>

              <div
                class="md-layout-item md-size-30 md-small-size-100 center-content ml-15 mt-25"
              >
                <md-button @click="Search" class="md-success btn_nanosoft"
                  >بحث</md-button
                >
              </div>
            </div>
          </md-card-content>
        </md-card>
      </form>
    </div>

    <div class="md-layout">
      <md-card>
        <md-card-header class="md-card-header-text md-card-header-green">
          <div class="card-text">
            <h4 class="title">إحصائيات الموظفين</h4>
          </div>
        </md-card-header>
        <md-card-content>
          <div class="md-layout">
            <div
              class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25"
            >
              <div class="md-card md-card-stats md-theme-default">
                <div
                  class="md-card-header md-card-header-icon md-card-header-green"
                >
                  <div class="card-text">
                    <p style="color: white" class="category">العدد الكلي</p>
                  </div>
                  <div
                    style="
                      display: flex;
                      margin-top: 25px;
                      margin-bottom: 23px;
                      font-size: large;
                      padding-right: 15px;
                    "
                  >
                    <p class="title cardHR" style="padding: 7px 40px">
                      <span style="padding-left: 5px">{{
                        dashboard.employeesTotalCount
                      }}</span
                      >موظف
                    </p>
                  </div>
                </div>
                <div class="md-card-actions md-alignment-left">
                  <a href="/pages/employees">
                    <div class="stats">
                      <!-- <i class="md-icon md-icon-font md-theme-default">remove_red_eye</i>
                                            مشاهدة -->
                    </div>
                  </a>
                </div>
              </div>
            </div>

            <div
              class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25"
            >
              <div class="md-card md-card-stats md-theme-default">
                <div
                  class="md-card-header md-card-header-icon md-card-header-green"
                >
                  <div class="card-text" style="width: max-content">
                    <p style="color: white" class="category">حسب الجنس</p>
                  </div>
                  <div
                    style="
                      display: flex;
                      margin-top: 25px;
                      margin-bottom: 23px;
                      font-size: large;
                      padding-right: 11px;
                    "
                  >
                    <p class="title cardHR">
                      <span style="padding-left: 5px">{{
                        dashboard.maleEmployeesTotalCount
                      }}</span
                      >ذكر
                    </p>
                    <p
                      class="title cardHR"
                      style="
                        margin-right: 20px;
                        color: #dc3545 !important;
                        border: 1px solid #dc3545;
                      "
                    >
                      <span style="padding-left: 5px">{{
                        dashboard.femaleEmployeesTotalCount
                      }}</span
                      >انثى
                    </p>
                  </div>
                </div>
                <div class="md-card-actions md-alignment-left">
                  <a href="/pages/employees">
                    <div class="stats">
                      <!-- <i class="md-icon md-icon-font md-theme-default">remove_red_eye</i>
                                            مشاهدة -->
                    </div>
                  </a>
                </div>
              </div>
            </div>

            <div
              class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25"
            >
              <div class="md-card md-card-stats md-theme-default">
                <div
                  class="md-card-header md-card-header-icon md-card-header-green"
                >
                  <div class="card-text" style="width: max-content">
                    <p
                      style="color: white; width: max-content"
                      class="category"
                    >
                      حسب نوع الجنسية
                    </p>
                  </div>
                  <div
                    style="
                      display: flex;
                      margin-top: 25px;
                      margin-bottom: 23px;
                      font-size: large;
                      margin-right: 7px;
                    "
                  >
                    <p class="title cardHR">
                      <span style="padding-left: 5px">{{
                        dashboard.localEmployeesTotalCount
                      }}</span
                      >وطني
                    </p>
                    <p
                      class="title cardHR"
                      style="
                        margin-right: 20px;
                        color: #dc3545 !important;
                        border: 1px solid #dc3545;
                      "
                    >
                      <span style="padding-left: 5px">{{
                        dashboard.foreignEmployeesTotalCount
                      }}</span
                      >اجنبي
                    </p>
                  </div>
                </div>
                <div class="md-card-actions md-alignment-left">
                  <a href="/pages/employees">
                    <div class="stats">
                      <!-- <i class="md-icon md-icon-font md-theme-default">remove_red_eye</i>
                                            مشاهدة -->
                    </div>
                  </a>
                </div>
              </div>
            </div>

            <div
              v-if="privateCompanyMode == 'false' || !privateCompanyMode"
              class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-100"
            >
              <div class="md-card md-card-stats md-theme-default">
                <div
                  class="md-card-header md-card-header-icon md-card-header-green"
                >
                  <div
                    class="card-text"
                    style="width: max-content; display: block"
                  >
                    <p style="color: white" class="category">حسب نوع التوظيف</p>
                  </div>
                  <div
                    style="
                      display: ruby;
                      margin-top: 25px;
                      font-size: large;
                      padding-right: 11px;
                    "
                  >
                    <router-link
                      v-if="
                        privateCompanyMode == 'false' || !privateCompanyMode
                      "
                      :to="`/pages/DesignationEmployees/${departmentId}`"
                    >
                      <p class="title cardHR">
                        <span style="padding-left: 5px">{{
                          dashboard.designationEmployeesCount
                        }}</span
                        >تعيين
                      </p>
                    </router-link>

                    <router-link
                      :to="`/pages/ContractEmployees/${departmentId}`"
                    >
                      <p
                        class="title cardHR"
                        style="
                          margin-right: 20px;
                          color: #007bff !important;
                          border: 1px solid #007bff;
                          margin-top: 20px !important;
                        "
                      >
                        <span style="padding-left: 5px">{{
                          dashboard.contractEmployeesCount
                        }}</span
                        >عقد
                      </p>
                    </router-link>

                    <router-link
                      v-if="
                        privateCompanyMode == 'false' || !privateCompanyMode
                      "
                      :to="`/pages/DelegationEmployees/${departmentId}`"
                    >
                      <p
                        class="title cardHR"
                        style="
                          margin-right: 20px;
                          color: #6c757d !important;
                          border: 1px solid #6c757d;
                          margin-top: 20px !important;
                        "
                      >
                        <span style="padding-left: 5px">{{
                          dashboard.delegationEmployeesCount
                        }}</span
                        >ندب
                      </p>
                    </router-link>

                    <router-link
                      v-if="
                        privateCompanyMode == 'false' || !privateCompanyMode
                      "
                      :to="`/pages/LoanEmployees/${departmentId}`"
                    >
                      <p
                        class="title cardHR"
                        style="
                          margin-right: 20px;
                          color: #dc3545 !important;
                          border: 1px solid #dc3545;
                          margin-top: 20px !important;
                        "
                      >
                        <span style="padding-left: 5px">{{
                          dashboard.loanEmployeesCount
                        }}</span
                        >إعارة
                      </p>
                    </router-link>

                    <router-link
                      v-if="
                        privateCompanyMode == 'false' || !privateCompanyMode
                      "
                      :to="`/pages/ClassifiedContractEmployees/${departmentId}`"
                    >
                      <p
                        class="title cardHR"
                        style="
                          margin-right: 20px;
                          color: #ffc107 !important;
                          border: 1px solid #ffc107;
                          margin-top: 20px !important;
                        "
                      >
                        <span style="padding-left: 5px">{{
                          dashboard.classifiedContractEmployeesCount
                        }}</span
                        >عقد مصنف
                      </p>
                    </router-link>
                    <router-link
                      v-if="
                        privateCompanyMode == 'false' || !privateCompanyMode
                      "
                      :to="`/pages/CooperativeContractEmployees/${departmentId}`"
                    >
                      <p
                        class="title cardHR"
                        style="
                          margin-right: 20px;
                          color: #343a40 !important;
                          border: 1px solid #343a40;
                          margin-top: 20px !important;
                        "
                      >
                        <span style="padding-left: 5px">{{
                          dashboard.cooperativeContractEmployeesCount
                        }}</span
                        >عقد متعاون
                      </p>
                    </router-link>
                    <router-link
                      :to="`/pages/NonJobTypeEmployees/${departmentId}`"
                    >
                      <p
                        class="title cardHR"
                        style="
                          margin-right: 20px;
                          color: #dc3545 !important;
                          border: 1px solid #dc3545;
                          margin-top: 20px !important;
                        "
                      >
                        <span style="padding-left: 5px">{{ without }}</span>
                        بدون
                      </p>
                    </router-link>
                  </div>
                </div>
                <div class="md-card-actions md-alignment-left">
                  <!-- <a>
                    <div class="stats">
                      <i class="md-icon md-icon-font md-theme-default">remove_red_eye</i>
                      مشاهدة
                    </div>
                  </a> -->
                </div>
              </div>
            </div>

            <div
              v-else
              class="md-layout-item md-medium-size-50 md-xsmall-size-25 md-size-25"
            >
              <div class="md-card md-card-stats md-theme-default">
                <div
                  class="md-card-header md-card-header-icon md-card-header-green"
                >
                  <div
                    class="card-text"
                    style="width: max-content; display: block"
                  >
                    <p style="color: white" class="category">حسب نوع التوظيف</p>
                  </div>
                  <div
                    style="display: flex; margin-top: 20px; font-size: large"
                  >
                    <router-link
                      :to="`/pages/ContractEmployees/${departmentId}`"
                    >
                      <p
                        class="title cardHR"
                        style="
                          margin-right: 20px;
                          color: #007bff !important;
                          border: 1px solid #007bff;
                          margin-top: 20px !important;
                        "
                      >
                        <span style="padding-left: 5px">{{
                          dashboard.contractEmployeesCount
                        }}</span
                        >عقد
                      </p>
                    </router-link>

                    <router-link
                      :to="`/pages/NonJobTypeEmployees/${departmentId}`"
                    >
                      <p
                        class="title cardHR"
                        style="
                          margin-right: 20px;
                          color: #dc3545 !important;
                          border: 1px solid #dc3545;
                          margin-top: 20px !important;
                        "
                      >
                        <span style="padding-left: 5px">{{ without }}</span>
                        بدون
                      </p>
                    </router-link>
                  </div>
                </div>
                <div
                  style="margin-bottom: 30px"
                  class="md-card-actions md-alignment-left"
                >
                  <!-- <a>
                    <div class="stats">
                      <i class="md-icon md-icon-font md-theme-default">remove_red_eye</i>
                      مشاهدة
                    </div>
                  </a> -->
                </div>
              </div>
            </div>

            <div class="md-layout-item md-size-100">
              <md-card>
                <md-card-header
                  class="md-card-header-text md-card-header-green"
                >
                  <div class="card-text">
                    <h4 class="title">حسب التقييم خلال آخر سنة</h4>
                  </div>
                </md-card-header>
                <md-card-content>
                  <md-table
                    class="paginated-table table-striped table-hover mt-25"
                  >
                    <md-table-row>
                      <md-table-cell>التقييم</md-table-cell>

                      <md-table-cell class="w-100">ممتاز</md-table-cell>

                      <md-table-cell class="w-100">جيد جدا</md-table-cell>

                      <md-table-cell class="w-100">متوسط</md-table-cell>
                      <md-table-cell class="w-100">جيد</md-table-cell>

                      <md-table-cell class="w-100">مقبول</md-table-cell>

                      <md-table-cell class="w-100">لايوجد</md-table-cell>
                    </md-table-row>
                    <md-table-row>
                      <md-table-cell md-label="الصنف">العدد</md-table-cell>

                      <md-table-cell class="w-100" md-label="الصنف">{{
                        dashboard.totalExcellentEmployeesCount
                      }}</md-table-cell>

                      <md-table-cell class="w-100" md-label="الصنف">{{
                        dashboard.totalVeryGoodEmployeesCount
                      }}</md-table-cell>

                      <md-table-cell class="w-100" md-label="الصنف">{{
                        dashboard.totalMediumEmployeesCount
                      }}</md-table-cell>

                      <md-table-cell class="w-100" md-label="الصنف">{{
                        dashboard.totalGoodEmployeesCount
                      }}</md-table-cell>

                      <md-table-cell class="w-100" md-label="الصنف">{{
                        dashboard.totalWeakEmployeesCount
                      }}</md-table-cell>

                      <md-table-cell class="w-100" md-label="الصنف">{{
                        dashboard.totalNotAvailableEmployeesCount
                      }}</md-table-cell>
                    </md-table-row>
                  </md-table>
                </md-card-content>
              </md-card>
            </div>

            <div class="md-layout-item md-size-100">
              <md-card>
                <md-card-header
                  class="md-card-header-text md-card-header-green"
                >
                  <div class="card-text">
                    <h4 class="title">حسب العمر</h4>
                  </div>
                </md-card-header>
                <md-card-content>
                  <md-table
                    class="paginated-table table-striped table-hover mt-25"
                  >
                    <md-table-row>
                      <md-table-cell>العمر</md-table-cell>

                      <md-table-cell class="w-100">أصغر من 25</md-table-cell>

                      <md-table-cell class="w-100">35-25</md-table-cell>

                      <md-table-cell class="w-100">45-35</md-table-cell>

                      <md-table-cell class="w-100">60-45</md-table-cell>
                      <md-table-cell class="w-100">اكبر من 60</md-table-cell>
                    </md-table-row>
                    <md-table-row>
                      <md-table-cell md-label="الصنف">العدد</md-table-cell>

                      <md-table-cell class="w-100" md-label="الصنف">{{
                        dashboard.employeesUnder25Years
                      }}</md-table-cell>

                      <md-table-cell class="w-100" md-label="الصنف">{{
                        dashboard.employeesBetween25And35Years
                      }}</md-table-cell>

                      <md-table-cell class="w-100" md-label="الصنف">{{
                        dashboard.employeesBetween35And45Years
                      }}</md-table-cell>

                      <md-table-cell class="w-100" md-label="الصنف">{{
                        dashboard.employeesBetween45And60Years
                      }}</md-table-cell>

                      <md-table-cell class="w-100" md-label="الصنف">{{
                        dashboard.employeesOver60Years
                      }}</md-table-cell>
                    </md-table-row>
                  </md-table>
                </md-card-content>
              </md-card>
            </div>
          </div>
        </md-card-content>
      </md-card>
    </div>

    <div
      v-if="privateCompanyMode == 'false' || !privateCompanyMode"
      class="md-layout"
    >
      <md-card>
        <md-card-header class="md-card-header-text md-card-header-green">
          <div class="card-text">
            <h4 class="title">
              إحصائيات العلاوات والترقيات للموظفين المستحقين
            </h4>
          </div>
        </md-card-header>
        <md-card-content>
          <div class="md-layout">
            <div
              class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25"
            >
              <div class="md-card md-card-stats md-theme-default">
                <div
                  class="md-card-header md-card-header-icon md-card-header-green"
                >
                  <div class="card-text" style="width: max-content">
                    <p style="color: white" class="category">للعلاوة الشهرية</p>
                  </div>
                  <div
                    style="
                      display: flex;
                      margin-top: 25px;
                      font-size: large;
                      padding-right: 15px;
                    "
                  >
                    <p class="title cardHR" style="padding: 7px 40px">
                      <span style="padding-left: 5px">{{
                        dashboard.totalEmployeesAboutToUpgradeBonuseCount
                      }}</span
                      >موظف
                    </p>
                  </div>
                </div>
                <div class="md-card-actions md-alignment-left">
                  <router-link
                    :to="`/pages/EmployeesAboutToUpgradeBonus/${departmentId}`"
                  >
                    <div class="stats">
                      <i class="md-icon md-icon-font md-theme-default"
                        >remove_red_eye</i
                      >
                      مشاهدة
                    </div>
                  </router-link>
                </div>
              </div>
            </div>

            <div
              class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25"
            >
              <div class="md-card md-card-stats md-theme-default">
                <div
                  class="md-card-header md-card-header-icon md-card-header-green"
                >
                  <div class="card-text" style="width: max-content">
                    <p style="color: white" class="category">
                      للترقية الوظيفية
                    </p>
                  </div>
                  <div
                    style="
                      display: flex;
                      margin-top: 25px;
                      font-size: large;
                      padding-right: 15px;
                    "
                  >
                    <p class="title cardHR" style="padding: 7px 40px">
                      <span style="padding-left: 5px">{{
                        dashboard.totalEmployeesAboutToUpgradeCount
                      }}</span
                      >موظف
                    </p>
                  </div>
                </div>
                <div class="md-card-actions md-alignment-left">
                  <router-link
                    :to="`/pages/EmployeesAboutToUpgrade/${departmentId}`"
                  >
                    <div class="stats">
                      <i class="md-icon md-icon-font md-theme-default"
                        >remove_red_eye</i
                      >
                      مشاهدة
                    </div>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </md-card-content>
      </md-card>
    </div>

    <div class="md-layout">
      <md-card>
        <md-card-header class="md-card-header-text md-card-header-green">
          <div class="card-text">
            <h4 class="title">إحصائيات الحضور والغياب وطلبات الإجازات</h4>
          </div>
        </md-card-header>
        <md-card-content>
          <div class="md-layout">
            <div
              class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-30"
            >
              <div class="md-card md-card-stats md-theme-default">
                <div
                  class="md-card-header md-card-header-icon md-card-header-green"
                >
                  <div class="card-text" style="width: max-content">
                    <p style="color: white" class="category">
                      ساعات العمل الاضافي حسب الشهر
                    </p>
                  </div>
                  <div
                    style="
                      display: flex;
                      margin-top: 25px;
                      font-size: large;
                      padding-right: 15px;
                    "
                  >
                    <p class="title cardHR" style="padding: 7px 60px">
                      <span style="padding-left: 5px">{{
                        dashboard.monthlyTotalOverTimeHours
                      }}</span
                      >ساعة
                    </p>
                  </div>
                </div>
                <div class="md-card-actions md-alignment-left">
                  <router-link :to="`/pages/OverTimeEmployees/${departmentId}`">
                    <div class="stats">
                      <i class="md-icon md-icon-font md-theme-default"
                        >remove_red_eye</i
                      >
                      مشاهدة
                    </div>
                  </router-link>
                </div>
              </div>
            </div>

            <!-- <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-30">
              <div class="md-card md-card-stats md-theme-default">
                <div class="md-card-header md-card-header-icon md-card-header-green">
                  <div class="card-text" style="width: max-content;">
                    <p style="color: white;" class="category">ساعات العمل الاضافي حسب السنة</p>
                  </div>
                  <div style="display: flex; margin-top: 25px ;font-size: large;padding-right: 15px;">
                    <p class="title cardHR" style="padding: 7px 60px;"><span style="  padding-left: 5px">{{
                      dashboard.yearlyTotalOverTimeHours }}</span>ساعة
                    </p>

                  </div>

                </div>
                <div class="md-card-actions md-alignment-left">
                  <a href="/pages/employees">
                    <div class="stats">
                      <i class="md-icon md-icon-font md-theme-default">remove_red_eye</i>
                      مشاهدة
                    </div>
                  </a>
                </div>
              </div>
            </div> -->

            <div
              class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-30"
            >
              <div class="md-card md-card-stats md-theme-default">
                <div
                  class="md-card-header md-card-header-icon md-card-header-green"
                >
                  <div class="card-text" style="width: max-content">
                    <p style="color: white" class="category">
                      الموظفين المتغيبين
                    </p>
                  </div>
                  <div
                    style="
                      display: flex;
                      margin-top: 25px;
                      font-size: large;
                      padding-right: 15px;
                    "
                  >
                    <p class="title cardHR" style="padding: 7px 60px">
                      <span style="padding-left: 5px">{{
                        dashboard.totalDailyAbsentEmployees
                      }}</span
                      >موظف
                    </p>
                  </div>
                </div>
                <div class="md-card-actions md-alignment-left">
                  <router-link :to="`/pages/AbsentEmployees/${departmentId}`">
                    <div class="stats">
                      <i class="md-icon md-icon-font md-theme-default"
                        >remove_red_eye</i
                      >
                      مشاهدة
                    </div>
                  </router-link>
                </div>
              </div>
            </div>

            <div
              class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-30"
            >
              <div class="md-card md-card-stats md-theme-default">
                <div
                  class="md-card-header md-card-header-icon md-card-header-green"
                >
                  <div class="card-text" style="width: max-content">
                    <p style="color: white" class="category">
                      المتجاوزين للحد المسموح بالغياب
                    </p>
                  </div>
                  <div
                    style="
                      display: flex;
                      margin-top: 25px;
                      font-size: large;
                      padding-right: 15px;
                    "
                  >
                    <p class="title cardHR" style="padding: 7px 60px">
                      <span style="padding-left: 5px">{{
                        dashboard.employeesGotMaximumAbsenceLimit
                      }}</span
                      >موظف
                    </p>
                  </div>
                </div>
                <div class="md-card-actions md-alignment-left">
                  <router-link
                    :to="`/pages/EmployeesGotMaximumAbsenceLimit/${departmentId}`"
                  >
                    <div class="stats">
                      <i class="md-icon md-icon-font md-theme-default"
                        >remove_red_eye</i
                      >
                      مشاهدة
                    </div>
                  </router-link>
                </div>
              </div>
            </div>

            <div
              class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-30"
            >
              <div class="md-card md-card-stats md-theme-default">
                <div
                  class="md-card-header md-card-header-icon md-card-header-green"
                >
                  <div class="card-text" style="width: max-content">
                    <p style="color: white" class="category">
                      عدد طلبات الإجازات المعلقة
                    </p>
                  </div>
                  <div
                    style="
                      display: flex;
                      margin-top: 25px;
                      font-size: large;
                      padding-right: 15px;
                    "
                  >
                    <p class="title cardHR" style="padding: 7px 60px">
                      <span style="padding-left: 5px">{{
                        dashboard.totalSuspendedVacation
                      }}</span>
                    </p>
                  </div>
                </div>
                <div class="md-card-actions md-alignment-left">
                  <a href="/pages/employees">
                    <div class="stats">
                      <i class="md-icon md-icon-font md-theme-default"
                        >remove_red_eye</i
                      >
                      مشاهدة
                    </div>
                  </a>
                </div>
              </div>
            </div>

            <!-- 
            <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-100">
              <div class="md-card md-card-stats md-theme-default">
                <div class="md-card-header md-card-header-icon md-card-header-green">
                  <div class="card-text" style="width: max-content">
                    <p style="color: white" class="category">
                      عدد طلبات الإجازات المعلقة
                    </p>
                  </div>
                  <div style="
                      display: flex;
                      margin-top: 25px;
                      font-size: large;
                      padding-right: 11px;
                    ">
                    <p class="title cardHR">
                      <span style="padding-left: 5px">20</span>إجازة سنوية
                    </p>
                    <p class="title cardHR" style="
                        margin-right: 20px;
                        color: #dc3545 !important;
                        border: 1px solid #dc3545;
                      ">
                      <span style="padding-left: 5px">10</span>إجازة طارئة
                    </p>

                    <p class="title cardHR" style="margin-right: 20px">
                      <span style="padding-left: 5px">5</span>إجازة مرضية
                    </p>

                    <p class="title cardHR" style="
                        margin-right: 20px;
                        color: #dc3545 !important;
                        border: 1px solid #dc3545;
                      ">
                      <span style="padding-left: 5px">30</span>إجازة بدون مرتب
                    </p>

                    <p class="title cardHR" style="margin-right: 20px">
                      <span style="padding-left: 5px">0</span>اجازة امومة
                    </p>
                  </div>
                </div>
                <div class="md-card-actions md-alignment-left">
                  <a href="/pages/employees">
                    <div class="stats">
                      <i class="md-icon md-icon-font md-theme-default">remove_red_eye</i>
                      مشاهدة
                    </div>
                  </a>
                </div>
              </div>
            </div> -->
          </div>
        </md-card-content>
      </md-card>
    </div>

    <div class="md-layout">
      <md-card>
        <md-card-header class="md-card-header-text md-card-header-green">
          <div class="card-text">
            <h4 class="title">إحصائيات التوظيف</h4>
          </div>
        </md-card-header>
        <md-card-content>
          <div class="md-layout">
            <div
              class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-30"
            >
              <div class="md-card md-card-stats md-theme-default">
                <div
                  class="md-card-header md-card-header-icon md-card-header-green"
                >
                  <div class="card-text">
                    <p style="color: white" class="category">
                      عدد الموظفين الجدد
                    </p>
                  </div>
                  <div
                    style="
                      display: flex;
                      margin-top: 25px;
                      font-size: large;
                      padding-right: 15px;
                    "
                  >
                    <p class="title cardHR" style="padding: 7px 60px">
                      <span style="padding-left: 5px">{{
                        dashboard.totalNewEmployeesThisYearCoun
                      }}</span
                      >موظف
                    </p>
                  </div>
                </div>
                <div class="md-card-actions md-alignment-left">
                  <router-link :to="`/pages/NewEmployees/${departmentId}`">
                    <div class="stats">
                      <i class="md-icon md-icon-font md-theme-default"
                        >remove_red_eye</i
                      >
                      مشاهدة
                    </div>
                  </router-link>
                </div>
              </div>
            </div>

            <div
              class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-30"
            >
              <div class="md-card md-card-stats md-theme-default">
                <div
                  class="md-card-header md-card-header-icon md-card-header-green"
                >
                  <div class="card-text" style="width: max-content">
                    <p style="color: white" class="category">
                      عدد الموظفين المنتهي خدمتهم
                    </p>
                  </div>
                  <div
                    style="
                      display: flex;
                      margin-top: 25px;
                      font-size: large;
                      padding-right: 15px;
                    "
                  >
                    <p class="title cardHR" style="padding: 7px 60px">
                      <span style="padding-left: 5px">{{
                        dashboard.totalEndedServiceCount
                      }}</span
                      >موظف
                    </p>
                  </div>
                </div>
                <div class="md-card-actions md-alignment-left">
                  <router-link
                    :to="`/pages/EndedServiceEmployees/${departmentId}`"
                  >
                    <div class="stats">
                      <i class="md-icon md-icon-font md-theme-default"
                        >remove_red_eye</i
                      >
                      مشاهدة
                    </div>
                  </router-link>
                </div>
              </div>
            </div>
            <!-- dd -->

            <div
              v-if="privateCompanyMode == 'false' || !privateCompanyMode"
              class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-30"
            >
              <div class="md-card md-card-stats md-theme-default">
                <div
                  class="md-card-header md-card-header-icon md-card-header-green"
                >
                  <div class="card-text" style="width: max-content">
                    <p style="color: white" class="category">
                      عدد الموظفين المقتربين لسن التقاعد
                    </p>
                  </div>
                  <div
                    style="
                      display: flex;
                      margin-top: 25px;
                      font-size: large;
                      padding-right: 15px;
                    "
                  >
                    <p class="title cardHR" style="padding: 7px 60px">
                      <span style="padding-left: 5px">{{
                        dashboard.totalEmployeesAboutToEndService
                      }}</span
                      >موظف
                    </p>
                  </div>
                </div>
                <div class="md-card-actions md-alignment-left">
                  <router-link
                    :to="`/pages/EmployeesAboutToEndService/${departmentId}`"
                  >
                    <div class="stats">
                      <i class="md-icon md-icon-font md-theme-default"
                        >remove_red_eye</i
                      >
                      مشاهدة
                    </div>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </md-card-content>
      </md-card>
    </div>

    <div class="md-layout">
      <md-card>
        <md-card-header class="md-card-header-text md-card-header-green">
          <div class="card-text">
            <h4 class="title">إحصائيات المرتبات لآخر شهر</h4>
          </div>
        </md-card-header>
        <md-card-content>
          <div class="md-layout">
            <div
              class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25"
            >
              <div class="md-card md-card-stats md-theme-default">
                <div
                  class="md-card-header md-card-header-icon md-card-header-green"
                >
                  <div class="card-text" style="width: max-content">
                    <p style="color: white" class="category">إجمالي المرتبات</p>
                  </div>
                  <div
                    style="
                      display: flex;
                      margin-top: 25px;
                      margin-bottom: 23px;
                      font-size: large;
                      padding-right: 15px;
                    "
                  >
                    <p class="title cardHR" style="padding: 7px 30px">
                      <span style="padding-left: 5px">{{
                        dashboard.thisMonthTotalSalaries
                      }}</span
                      >د.ل
                    </p>
                  </div>
                </div>
                <div class="md-card-actions md-alignment-left">
                  <a href="/pages/employees">
                    <div class="stats">
                      <!-- <i class="md-icon md-icon-font md-theme-default">remove_red_eye</i>
                                            مشاهدة -->
                    </div>
                  </a>
                </div>
              </div>
            </div>

            <div
              class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25"
            >
              <div class="md-card md-card-stats md-theme-default">
                <div
                  class="md-card-header md-card-header-icon md-card-header-green"
                >
                  <div class="card-text" style="width: max-content">
                    <p style="color: white" class="category">إجمالي الصافي</p>
                  </div>
                  <div
                    style="
                      display: flex;
                      margin-top: 25px;
                      margin-bottom: 23px;
                      font-size: large;
                      padding-right: 15px;
                    "
                  >
                    <p class="title cardHR" style="padding: 7px 30px">
                      <span style="padding-left: 5px">{{
                        dashboard.thisMonthNetSalaries
                      }}</span
                      >د.ل
                    </p>
                  </div>
                </div>
                <div class="md-card-actions md-alignment-left">
                  <a href="/pages/employees">
                    <div class="stats">
                      <!-- <i class="md-icon md-icon-font md-theme-default">remove_red_eye</i>
                                            مشاهدة -->
                    </div>
                  </a>
                </div>
              </div>
            </div>

            <div
              class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25"
            >
              <div class="md-card md-card-stats md-theme-default">
                <div
                  class="md-card-header md-card-header-icon md-card-header-green"
                >
                  <div class="card-text" style="width: max-content">
                    <p style="color: white" class="category">إجمالي الخصميات</p>
                  </div>
                  <div
                    style="
                      display: flex;
                      margin-top: 25px;
                      margin-bottom: 23px;
                      font-size: large;
                      padding-right: 15px;
                    "
                  >
                    <p class="title cardHR" style="padding: 7px 30px">
                      <span style="padding-left: 5px">{{
                        dashboard.thisMonthTotalDiscounts
                      }}</span
                      >د.ل
                    </p>
                  </div>
                </div>
                <div class="md-card-actions md-alignment-left">
                  <a href="/pages/employees">
                    <div class="stats">
                      <!-- <i class="md-icon md-icon-font md-theme-default">remove_red_eye</i>
                                            مشاهدة -->
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>

<script>
import axios from "../../../../components/service/HTTP.js";
import { Pagination } from "@/components";
import Fuse from "fuse.js";
import Swal from "sweetalert2";
import env from "../../../../../env";
export default {
  async created() {
    if (this.globalEmployeesData) {
      await this.init();
    }

    this.privateCompanyMode = localStorage.getItem("privateCompanyMode");
  },
  // async mounted() {
  //   if (this.globalEmployeesData) {
  //     await this.init();
  //   }
  // },

  components: {
    Pagination,

    // SlideYDownTransition
  },
  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */

    globalEmployeesData() {
      return this.$store.getters["global/employeesData"];
    },

    queriedData() {
      let result = this.tableData;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    },
  },
  data() {
    return {
      privateCompanyMode: false,
      departments: [],
      departmentId: null,
      without: 0,
      errorMessage: "",
      Name: "",
      btn: "new",
      idTable: "",
      dashboard: "",
      employeesTotalCount: 0,

      /////////////////
      pagination: {
        perPage: 25,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },
      currentSort: "Titel",
      currentSortOrder: "asc",
      searchQuery: "",
      propsToSearch: ["Titel", "Severity", "Status"],
      tableData: [],
      searchedData: [],
      fuseSearch: null,
    };
  },
  methods: {
    async Search() {
      try {
        this.tableData = [];
        let T = localStorage.getItem("Nannotoken");
        let token = atob(T);
        let result = await axios.get(
          `${env.HR()}/api/dashboard?DepartmentId=${this.departmentId}`,

          {
            headers: { Authorization: "Bearer " + token },
          }
        );
        this.dashboard = result.data.data;

        this.without =
          this.dashboard.employeesTotalCount -
          (this.dashboard.designationEmployeesCount +
            this.dashboard.contractEmployeesCount +
            this.dashboard.delegationEmployeesCount +
            this.dashboard.loanEmployeesCount +
            this.dashboard.classifiedContractEmployeesCount +
            this.dashboard.cooperativeContractEmployeesCount);
      } catch (error) {
        return this.notifyVue(
          "top",
          "center",
          "danger",
          "الرجاء اعادة تسجيل الدخول"
        );
      }
    },
    showSwal(type) {
      if (type === "title-and-text") {
        Swal.fire({
          title: `Here's a message!`,
          text: `It's pretty, isn't it?`,
          buttonsStyling: false,
          confirmButtonClass: "md-button md-info",
        });
      }
    },
    message(error) {
      if (error.response.data.message != undefined) {
        this.errorMessage = error.response.data.message;
      } else {
        this.errorMessage =
          error.response.data.errors[
            Object.keys(error.response.data.errors)[0]
          ][0];
      }

      return this.notifyVue("top", "center", "danger", this.errorMessage);
    },

    async Save() {
      try {
        let T = localStorage.getItem("Nannotoken");
        let token = atob(T);

        if (!this.Name) {
          return this.notifyVue(
            "top",
            "center",
            "danger",
            "عفواً، الرجاء ادخال اسم المصرف"
          );
        }

        let schema = {
          Name: this.Name,
        };

        if (this.btn === "new") {
          let result = await axios.post(`${env.HR()}/api/banks`, schema, {
            headers: { Authorization: "Bearer " + token },
          });
        } else {
          let result = await axios.put(
            `${env.HR()}/api/banks/${this.idTable}`,
            schema,
            {
              headers: { Authorization: "Bearer " + token },
            }
          );
        }

        this.init();
        this.clear();
        this.btn = "new";
        return this.notifyVue("top", "center", "success", " تم الحفظ بنجاح ");
      } catch (error) {
        this.message(error);
      }
    },
    async init() {
      try {
        let T = localStorage.getItem("Nannotoken");
        let token = atob(T);
        let result = await axios.get(`${env.HR()}/api/dashboard`, {
          headers: { Authorization: "Bearer " + token },
        });

        this.dashboard = result.data.data;

        this.without =
          this.dashboard.employeesTotalCount -
          (this.dashboard.designationEmployeesCount +
            this.dashboard.contractEmployeesCount +
            this.dashboard.delegationEmployeesCount +
            this.dashboard.loanEmployeesCount +
            this.dashboard.classifiedContractEmployeesCount +
            this.dashboard.cooperativeContractEmployeesCount);
        this.departments = this.globalEmployeesData.departments;
        // this.employeesTotalCount = result.data.data.employeesTotalCount;
      } catch (error) {
        return this.notifyVue(
          "top",
          "center",
          "danger",
          "الرجاء اعادة تسجيل الدخول"
        );
      }
    },
    customSort(value) {
      return value.sort((a, b) => {
        const sortBy = this.currentSort;
        if (this.currentSortOrder === "desc") {
          return a[sortBy].localeCompare(b[sortBy]);
        }
        return b[sortBy].localeCompare(a[sortBy]);
      });
    },
    handleLike(item) {
      Swal.fire({
        title: `You liked ${item.name}`,
        buttonsStyling: false,
        type: "success",
        confirmButtonClass: "md-button md-success",
      });
    },

    async handleEdit(item) {
      const offsetTop = document.getElementById("#content");
      scroll({
        top: offsetTop,
        behavior: "smooth",
      });

      (this.Name = item.name), (this.btn = "Edit");
      this.idTable = item.id;
    },

    clear() {
      (this.Name = ""), (this.btn = "new");
    },
    handleDelete(item) {
      Swal.fire({
        text: "سيتم الحذف هل انت متأكد ؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-success btn-fill",
        cancelButtonClass: "md-button md-danger btn-fill",
        confirmButtonText: "نعم",
        cancelButtonText: "لا",
        buttonsStyling: false,
      }).then(async (result) => {
        if (result.value) {
          try {
            let T = localStorage.getItem("Nannotoken");
            let token = atob(T);
            let result = await axios.delete(
              `${env.HR()}/api/banks/${item.id}`,
              {
                headers: { Authorization: "Bearer " + token },
              }
            );
            this.deleteRow(item);
            return this.notifyVue(
              "top",
              "center",
              "success",
              "تم الحذف بنجاح "
            );
          } catch (error) {
            let result =
              error.response.data.errors[
                Object.keys(error.response.data.errors)[0]
              ];
            return this.notifyVue("top", "center", "danger", result[0]);
          }
        }
      });
    },
    deleteRow(item) {
      let indexToDelete = this.tableData.findIndex(
        (tableRow) => tableRow.id === item.id
      );
      if (indexToDelete >= 0) {
        this.tableData.splice(indexToDelete, 1);
      }
    },
    notifyVue(verticalAlign, horizontalAlign, type, message, time = 10000) {
      this.$notify({
        timeout: time,
        message: message,
        icon: "add_alert",
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: type,
      });
    },
  },
  mounted() {
    // Fuse search initialization.
    this.fuseSearch = new Fuse(this.tableData, {
      keys: ["Titel", "SystemVersion"],
      threshold: 0.3,
    });
  },
  watch: {
    globalEmployeesData(newValue) {
      this.init();
    },
    searchQuery(value) {
      let result = this.tableData;
      if (value !== "") {
        result = this.fuseSearch.search(this.searchQuery);
      }
      this.searchedData = result;
    },
  },
};
</script>

<style>
.validate {
  position: absolute;
  top: -3px;
  right: -13px;
  color: red;
}

.cardHR {
  background: white;
  color: #43a047 !important;
  border-radius: 3px;
  border: 3px;
  border: 1px solid #43a047;
  padding: 7px;
}

.md-card {
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.34) !important;
}
</style>
